import { CreateForm } from "./CreateForm";
import { CategoryForm } from "./CategoryForm";
import { EditForm } from "./EditForm";
import { List } from "./List";

export default {
  CategoryForm,
  CreateForm,
  EditForm,
  List,
};
